import React, {useEffect, useRef, useState} from "react";
import _ from "lodash";
import AjaxButton from "../../../form/ajax_button";
import classNames from "classnames";
import {useSelector} from "react-redux";
import {filterMessagesForChat, useChats, useUnreadMessages} from "./utils";
import moment from "moment";
import {ChatPreview} from "./chat_preview";
import axios from "axios";

export default function DirectMessagingOverview({setShowParticipants, setSearchResults, translations}) {
  const searchButtonRef = useRef(null);
  const searchUrl = useSelector((state) => state.directMessaging.searchUrl)
  const directMessageOverviewTextHtml = useSelector((state) => state.directMessaging.directMessageOverviewTextHtml)
  const directMessageCompleteParticipantListUrl = useSelector((state) => state.directMessaging.directMessageCompleteParticipantListUrl)
  const chats = useChats()
  const useOnlineStatus = useSelector((state) => state.directMessaging?.useOnlineStatus)
  const [isLoadingParticipantList, setIsLoadingParticipantList] = useState(useOnlineStatus)
  const [participantList, setParticipantList] = useState([])

  const UserSearchField = () => {
    const [searchText, setSearchText] = useState("");

    const handleSearchInput = (event) => {
      if (event.key === 'Enter' && searchText) {
        event.preventDefault()
        event.stopPropagation()
        searchButtonRef.current.click()
      }
    }
    return <>
      <input
        className="form-control"
        type="text"
        onKeyDown={handleSearchInput}
        placeholder={translations.searchForMembersPlaceholder || "Search for other members"}
        value={searchText}
        onChange={(event) => {
          setSearchText(event.target.value)
        }}
      />
      {searchText && <div className="input-group-append">
        <AjaxButton
          method="post"
          labelSending={translations.searchForMembersButtonSending || "Sending ..."}
          className={classNames("btn btn-dark user-search-button")}
          icon="fa-save"
          buttonRef={searchButtonRef}
          url={searchUrl}
          data={{
            search_text: searchText
          }}
          label={translations.searchForMembersButtonLabel || "Search"}
          onSuccess={(data) => {
            if (data.data.status === "OK") {
              setSearchResults(data.data.tagOwnerResults)
            } else {
              alert(data.data.message || "A error occured while searching.")
            }
          }}
          onError={(error) => {
            console.log(error)
            alert("Error sending chat message", error)
          }}
        />
      </div>}
    </>
  }

  const ShowParticipantsListButton = () => {
    return <div className={"row"} style={{width: "100%"}}>
      <div className="col-12 text-center">
        <button className={"btn btn-outline-success btn-ueg btn-ueg-styled"} onClick={() => setShowParticipants(true)}>
          {translations.showChatContactsText || "SHOW CHAT CONTACTS"}
        </button>
      </div>
    </div>
  }

  useEffect(() => {
    if (useOnlineStatus && chats.length > 0) {
      setIsLoadingParticipantList(true)

      axios.post(directMessageCompleteParticipantListUrl, {tag_owner_ids: chats.map(chat => chat.tagOwner.id)}).then(data => {
          if (data.data.status === "OK") {
            setParticipantList(data.data.tagOwnerResults)
          } else {
            alert(data.data.message || "A error occurred while loading.")
          }
          setIsLoadingParticipantList(false)
        },
        error => {
          alert(error)
          console.error(error)
          setParticipantList([])
        }).then(function () {
        setIsLoadingParticipantList(false)
      })
    }
  }, [])


  return <>
    <div className="col-12 direct-messaging-header">
      <div dangerouslySetInnerHTML={{__html: directMessageOverviewTextHtml}}/>
      <div className="input-group chat-window-input-form-group text-center">
        {directMessageCompleteParticipantListUrl ? <ShowParticipantsListButton/> : <UserSearchField/>}
      </div>
    </div>
    <div className="row limited-height-container">
      <div className="col-12">

        {chats.map((chat) => {
          let onlineState = null

          if (useOnlineStatus) {
            if (isLoadingParticipantList) {
              onlineState = "loading"
            } else if (participantList.some(tagOwner => tagOwner.id === chat.tagOwner.id && tagOwner.is_online)) {
              onlineState = "online"
            } else {
              onlineState = "offline"
            }
          }

          return <ChatPreview key={chat.tagOwner.id}
                              chat={chat}
                              onlineState={onlineState}
                              setSearchResults={setSearchResults}
                              translations={translations} />
        })}
      </div>
    </div>
  </>;
}